import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  CButton,
  CCollapse,
  CContainer,
  CNav,
  CNavItem,
  CNavbar,
  CNavbarToggler,
} from "@coreui/react";

const marketingNavItems = [
  { label: "Produkte", href: "#produkte" },
  { label: "Für Bewerber", href: "#fuer-bewerber" },
  { label: "Für Arbeitgeber", href: "#fuer-arbeitgeber" },
  { label: "Support", href: "/menue/support" },
];

const authNavItems = [
  { label: "Startseite", href: "/" },
  { label: "Jobs", href: "/stb/job-marketplace" },
  { label: "Support", href: "/menue/support" },
];

function PublicNavLink({ item, className, onNavigate }) {
  const isHashLink = item.href.startsWith("#");

  if (isHashLink) {
    return (
      <a href={item.href} className={className} onClick={onNavigate}>
        {item.label}
      </a>
    );
  }

  return (
    <Link to={item.href} className={className} onClick={onNavigate}>
      {item.label}
    </Link>
  );
}

export default function PublicHeader({ mode = "marketing", activeAuthPath = null }) {
  const navigate = useNavigate();
  const location = useLocation();
  const navItems = mode === "auth" ? authNavItems : marketingNavItems;
  const [mobileVisible, setMobileVisible] = useState(false);

  useEffect(() => {
    setMobileVisible(false);
  }, [location.pathname]);

  return (
    <CNavbar expand="lg" className={`public-core-navbar public-core-navbar--${mode}`}>
      <CContainer fluid className="public-core-container">
        <div className="public-core-navbar__shell">
          <div className="public-core-navbar__top">
            <Link to="/" className="public-core-brand" aria-label="Experts4Europe Startseite">
              <span className="public-core-brand__mark">E4E</span>
              <span className="public-core-brand__copy">
                <strong>Experts4Europe</strong>
                <small>
                  {mode === "auth"
                    ? "Zugang, Registrierung und strukturierte nächste Schritte"
                    : "Jobs, Qualifikationen und nächste Schritte in Europa"}
                </small>
              </span>
            </Link>

            <div className="public-core-navbar__desktop">
              <CNav className="public-core-nav public-core-nav--desktop" component="nav">
                {navItems.map((item) => (
                  <CNavItem key={item.label}>
                    <PublicNavLink item={item} className="public-core-nav__link" />
                  </CNavItem>
                ))}
              </CNav>

              <div className="public-core-navbar__actions public-core-navbar__actions--desktop">
                {mode === "auth" ? (
                  <>
                    <CButton
                      type="button"
                      className={`public-core-btn ${
                        activeAuthPath === "/login" ? "public-core-btn--subtle is-current" : "public-core-btn--ghost"
                      }`.trim()}
                      onClick={() => navigate("/login")}
                    >
                      Anmelden
                    </CButton>
                    <CButton
                      type="button"
                      className={`public-core-btn ${
                        activeAuthPath === "/register" ? "public-core-btn--primary is-current" : "public-core-btn--subtle"
                      }`.trim()}
                      onClick={() => navigate("/register")}
                    >
                      Registrieren
                    </CButton>
                  </>
                ) : (
                  <>
                    <CButton type="button" className="public-core-btn public-core-btn--ghost" onClick={() => navigate("/login")}>
                      Login
                    </CButton>
                    <CButton type="button" className="public-core-btn public-core-btn--primary" onClick={() => navigate("/register")}>
                      Registrieren
                    </CButton>
                  </>
                )}
              </div>
            </div>

            <CNavbarToggler
              className="public-core-navbar__toggler"
              aria-label="Navigation ein- oder ausblenden"
              aria-expanded={mobileVisible}
              onClick={() => setMobileVisible((current) => !current)}
            />
          </div>

          <CCollapse visible={mobileVisible} className="public-core-navbar__collapse">
            <CNav className="public-core-nav public-core-nav--mobile" component="nav">
              {navItems.map((item) => (
                <CNavItem key={item.label}>
                  <PublicNavLink
                    item={item}
                    className="public-core-nav__link public-core-nav__link--mobile"
                    onNavigate={() => setMobileVisible(false)}
                  />
                </CNavItem>
              ))}
            </CNav>

            <div className="public-core-navbar__actions public-core-navbar__actions--mobile">
              {mode === "auth" ? (
                <>
                  <CButton
                    type="button"
                    className={`public-core-btn ${
                      activeAuthPath === "/login" ? "public-core-btn--subtle is-current" : "public-core-btn--ghost"
                    }`.trim()}
                    onClick={() => navigate("/login")}
                  >
                    Anmelden
                  </CButton>
                  <CButton
                    type="button"
                    className={`public-core-btn ${
                      activeAuthPath === "/register" ? "public-core-btn--primary is-current" : "public-core-btn--subtle"
                    }`.trim()}
                    onClick={() => navigate("/register")}
                  >
                    Registrieren
                  </CButton>
                </>
              ) : (
                <>
                  <CButton type="button" className="public-core-btn public-core-btn--ghost" onClick={() => navigate("/login")}>
                    Login
                  </CButton>
                  <CButton type="button" className="public-core-btn public-core-btn--primary" onClick={() => navigate("/register")}>
                    Registrieren
                  </CButton>
                </>
              )}
            </div>
          </CCollapse>
        </div>
      </CContainer>
    </CNavbar>
  );
}
